import React, { useState } from "react";
import FormInput from "../components/FormInput";

// import UniversalPageHeader from "../components/UniversalPageHeader";
import "../styles/Contact.css";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  // State to hold the response message from the backend
  const [responseMessage, setResponseMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setResponseMessage("");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/ct/contact`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-App-Secret": process.env.REACT_APP_APP_SECRET,
          },
          body: JSON.stringify(formData),
        }
      );

      const result = await response.json();

      if (!response.ok) {
        // If the backend returned an error status, show the error message.
        setResponseMessage(
          result.message || "An error occurred. Please try again."
        );
      } else {
        // On success, show the success message from the backend.
        setResponseMessage(result.message);
        // Optionally clear the form after successful submission
        setFormData({
          name: "",
          email: "",
          subject: "",
          message: "",
        });
      }
    } catch (error) {
      console.error("Error submitting the form:", error);
      setResponseMessage("An error occurred. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <div className="contact-us-container">
      <div className="contact-header">
        <div className="contact-us-info">
          <h1>Getting in Touch</h1>
          <p>Available Monday to Friday, 9:00 AM to 5:00 PM (GMT).</p>
        </div>
      </div>
      <div className="contact-form-container">
        <h2>Contact us</h2>
        <form className="contact-form" onSubmit={handleSubmit}>
          <FormInput
            label="Full name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            rows={1}
          />
          <FormInput
            label="Email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            rows={1}
          />
          <FormInput
            label="Subject"
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            rows={1}
          />
          <FormInput
            label="Message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            rows={5}
          />
          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Submitting..." : "Submit"}
          </button>
        </form>
        {responseMessage && (
          <div className="response-message">
            <p>{responseMessage}</p>
          </div>
        )}
      </div>
    </div>
  );
}
